import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { StepConnector, makeStyles, withStyles } from '@material-ui/core';
import { AttachMoney, CheckCircle, Person, ShoppingCart } from '@material-ui/icons';

// eslint-disable-next-line import/no-extraneous-dependencies
import clsx from 'clsx';
import { useFeatureFlag } from 'configcat-react';
import { object, string } from 'prop-types';

import { Container, StepLabelStyled, StepStyled, StepperHeader } from './styles';

// eslint-disable-next-line react/no-multi-comp
function HeaderStepsIcons({ asPath, featureFlags }) {
  const theme = useSelector(({ app }) => app.getIn(['config', 'theme']));
  const isSigned = useSelector(({ customer }) => customer.getIn(['signed']));
  const blackFridayColors = useFeatureFlag('black_friday_colors', featureFlags?.black_friday_colors ?? false)?.value;

  const COLORS = {
    A: '#a8ff00',
    B: theme.colors.headerText,
  };

  const [activeStep, setActiveStep] = useState(0);
  const ColorlibConnector = withStyles({
    alternativeLabel: {
      top: 22,
      left: 'calc(-50% + 16px)',
      right: 'calc(50% + 16px)',
    },
    active: {
      '& $line': {
        borderColor: COLORS[theme.getIn(['template'])],
      },
    },
    completed: {
      '& $line': {
        borderColor: `${COLORS[theme.getIn(['template'])]}90`,
      },
    },
    line: {
      borderColor: theme?.colors?.headerHover ?? '#00000030',
      borderTopWidth: 1,
      borderRadius: 1,
    },
  })(StepConnector);

  const useColorlibStepIconStyles = makeStyles({
    root: {
      zIndex: 1,
      width: 40,
      height: 40,
      display: 'flex',
      borderRadius: '50%',
      justifyContent: 'center',
      alignItems: 'center',
      '& svg': { color: blackFridayColors ? '#ffffff44' : '#00000030' },
    },
    active: {
      '& svg': { color: COLORS[theme.getIn(['template'])] },
    },
    completed: {
      '& svg': { color: `${COLORS[theme.getIn(['template'])]}90` },
    },
  });

  // eslint-disable-next-line react/no-multi-comp
  const ColorlibStepIcon = (props) => {
    const classes = useColorlibStepIconStyles();
    // eslint-disable-next-line react/prop-types
    const { active, completed, icon } = props;

    const icons = {
      1: <ShoppingCart />,
      2: <Person />,
      3: <AttachMoney />,
      4: <CheckCircle />,
    };

    return (
      <div
        className={clsx(classes.root, {
          [classes.active]: active,
          [classes.completed]: completed,
        })}
      >
        {icons[String(icon)]}
      </div>
    );
  };

  useEffect(() => {
    if (asPath.includes('carrinho')) {
      setActiveStep(0);
    }
    if (asPath.includes('checkout')) {
      setActiveStep(1);
    }
    if (asPath.includes('checkout') && isSigned) {
      setActiveStep(2);
    }
    if (asPath.includes('totem')) {
      setActiveStep(2);
    }
    if (asPath.includes('confirmacao')) {
      setActiveStep(3);
    }
  }, [asPath, isSigned]);

  const steps = ['CARRINHO', 'LOGIN', 'CHECKOUT', 'CONFIRMAÇÃO'];

  if (asPath.includes('/cliente')) {
    return null;
  }

  return (
    <Container>
      <StepperHeader alternativeLabel connector={<ColorlibConnector />} activeStep={activeStep}>
        {steps.map((label) => (
          <StepStyled key={label}>
            <StepLabelStyled
              blackFridayColors={blackFridayColors}
              StepIconComponent={ColorlibStepIcon}
              themecolor={COLORS[theme.getIn(['template'])]}
            >
              {label}
            </StepLabelStyled>
          </StepStyled>
        ))}
      </StepperHeader>
    </Container>
  );
}

HeaderStepsIcons.propTypes = {
  asPath: string,
  featureFlags: object,
};

export default HeaderStepsIcons;
